import Konva from 'konva';
import {useCallback, useEffect, useState} from 'react';

type UseImageHandlersType = {
  rawSrc: string | undefined;
  layerRef: React.RefObject<Konva.Layer>;
  transformerRef: React.RefObject<Konva.Transformer>;

  clean: () => void;
  setIsImageBusy: (value: boolean) => void;
  setIsImageError: (value: boolean) => void;
};

export function useImageHandler({
  rawSrc,
  layerRef,
  transformerRef,
  clean,
  setIsImageBusy,
  setIsImageError,
}: UseImageHandlersType) {
  const [src, setSrc] = useState(rawSrc);

  useEffect(
    function updateImage() {
      if (src !== rawSrc) {
        transformerRef.current?.nodes([]);
        layerRef.current?.draw();

        setSrc(rawSrc);
        clean();
      }
    },
    [src, rawSrc, setSrc, clean, layerRef, transformerRef]
  );

  const onError = useCallback(() => setIsImageError(true), [setIsImageError]);

  const onFinishLoading = useCallback(() => setIsImageBusy(false), [setIsImageBusy]);

  const onStartLoading = useCallback(() => {
    setIsImageBusy(true);
    setIsImageError(false);
  }, [setIsImageBusy, setIsImageError]);

  return {
    src,
    setSrc,
    onError,
    onFinishLoading,
    onStartLoading,
  };
}
